import { render } from "./gserver.vue?vue&type=template&id=dd9b22d0&scoped=true"
import script from "./gserver.vue?vue&type=script&lang=js"
export * from "./gserver.vue?vue&type=script&lang=js"

import "./gserver.vue?vue&type=style&index=0&id=dd9b22d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9b22d0"]])

export default __exports__